// VersionChecker.tsx
import { useEffect, useState } from "react";
import { getAppVersion } from "../../api/app-update";

// 로컬 스토리지에 저장된 버전 키
const VERSION_KEY = "app_version";

interface VersionCheckerProps {
  versionCheckInterval?: number; // 버전 체크 간격 (밀리초)
  onNewVersion?: () => void; // 새 버전 감지 시 실행할 콜백
}

const VersionChecker: React.FC<VersionCheckerProps> = ({
  versionCheckInterval = 60 * 1000, // 기본값: 1분
  onNewVersion,
}) => {
  const [checking, setChecking] = useState<boolean>(false);

  // 버전 체크 함수
  const checkVersion = async () => {
    // 이미 체크 중이면 중복 실행 방지
    if (checking) return;
    try {
      setChecking(true);

      // API에서 최신 버전 정보 가져오기
      const response = await getAppVersion();

      const serverVersion = response.front; // API 응답에서 버전 추출
      //alert(JSON.stringify(response));
      // 로컬에 저장된 버전 가져오기
      const localVersion = localStorage.getItem(VERSION_KEY);

      // 버전 비교
      if (localVersion === null) {
        // 처음 실행 시 버전 저장
        localStorage.setItem(VERSION_KEY, serverVersion);
      } else if (localVersion + "" !== serverVersion + "") {
        console.log(`새 버전 감지: ${localVersion} → ${serverVersion}`);

        // 캐시 삭제
        clearBrowserCache();

        // 로컬 버전 업데이트
        localStorage.setItem(VERSION_KEY, serverVersion);

        // 콜백 실행
        if (onNewVersion) {
          onNewVersion();
        } else {
          // 기본 동작: 페이지 새로고침
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("버전 확인 중 오류 발생:", error);
    } finally {
      setChecking(false);
    }
  };

  // 브라우저 캐시 삭제 함수
  const clearBrowserCache = () => {
    // 서비스 워커가 있는 경우 캐시 삭제
    if ("caches" in window) {
      caches.keys().then((keyList) => {
        return Promise.all(
          keyList.map((key) => {
            return caches.delete(key);
          })
        );
      });
    }
  };

  useEffect(() => {
    checkVersion();
    // 정기적으로 버전 체크
    const intervalId = setInterval(checkVersion, versionCheckInterval);

    // 컴포넌트 언마운트 시 인터벌 해제
    return () => clearInterval(intervalId);
  }, [versionCheckInterval]);

  // UI를 렌더링하지 않는 유틸리티 컴포넌트
  return null;
};

export default VersionChecker;
